(function () {
  class OlitansGlassCartSuccess {
    constructor(root) {
      this.root = root;
      this.sheet = root.querySelector('.olitans-glass-sheet');
      this.backdrop = root.querySelector('.olitans-glass-backdrop');
      this.image = root.querySelector('[data-olitans-glass-product-image]');
      this.title = root.querySelector('[data-olitans-glass-product-title]');
      this.variant = root.querySelector('[data-olitans-glass-product-variant]');
      this.price = root.querySelector('[data-olitans-glass-product-price]');
      this.recommendationsGrid = root.querySelector('[data-olitans-glass-recommendations-grid]');
      this.buttons = root.querySelectorAll('.olitans-glass-button');
      this.checkoutLinks = root.querySelectorAll('.olitans-glass-button-primary');
      this.cartLinks = root.querySelectorAll('[data-olitans-glass-cart-link]');
      this.autoCloseTimer = null;
      this.recommendationRequestId = 0;
      this.drag = null;
      this.isOpen = false;

      this.checkoutLinks.forEach((link) => {
        link.href = root.dataset.checkoutUrl || '/checkout';
        link.addEventListener('click', this.onActionLinkClick.bind(this));
      });

      this.cartLinks.forEach((link) => {
        link.href = root.dataset.cartUrl || '/cart';
        link.addEventListener('click', this.onActionLinkClick.bind(this));
      });

      root.querySelectorAll('[data-olitans-glass-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      this.buttons.forEach((button) => {
        this.bindButtonFeedback(button);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.isOpen) this.close();
      });

      document.addEventListener('olitans:cart-success', (event) => {
        this.show(event.detail || {});
      });

      this.sheet.addEventListener('pointerdown', this.onPointerDown.bind(this));
    }

    resetCheckoutLinks() {
      this.checkoutLinks.forEach((link) => {
        link.classList.remove('is-loading');
        link.removeAttribute('aria-busy');
      });
      this.cartLinks.forEach((link) => {
        link.classList.remove('is-loading');
        link.removeAttribute('aria-busy');
      });
    }

    onActionLinkClick(event) {
      var link = event.currentTarget;
      var isModifiedClick = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0;

      if (isModifiedClick || link.target === '_blank') return;

      event.preventDefault();
      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');

      window.setTimeout(() => {
        window.location.href = link.href;
      }, 80);
    }

    bindButtonFeedback(button) {
      var release = () => button.classList.remove('is-pressed');

      button.addEventListener('pointerdown', () => {
        button.classList.add('is-pressed');
      });
      button.addEventListener('pointerup', release);
      button.addEventListener('pointerleave', release);
      button.addEventListener('pointercancel', release);
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') button.classList.add('is-pressed');
      });
      button.addEventListener('keyup', release);
      button.addEventListener('blur', release);
    }

    show(detail) {
      var item = this.resolveItem(detail);

      this.updateProduct(item);
      this.loadRecommendations(item);
      this.resetCheckoutLinks();
      this.root.hidden = false;
      this.root.setAttribute('aria-hidden', 'false');
      this.root.classList.remove('is-closing');
      this.root.classList.add('is-visible');
      this.isOpen = true;

      this.playIn();
      this.resetAutoClose();
    }

    close() {
      if (!this.isOpen) return;

      this.isOpen = false;
      window.clearTimeout(this.autoCloseTimer);
      this.root.classList.add('is-closing');
      this.root.classList.remove('is-visible');
      this.playOut();

      window.setTimeout(() => {
        if (this.isOpen) return;
        this.root.hidden = true;
        this.root.setAttribute('aria-hidden', 'true');
        this.root.classList.remove('is-closing');
        this.sheet.style.transform = '';
        this.sheet.style.opacity = '';
      }, 320);
    }

    resetAutoClose() {
      window.clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = window.setTimeout(() => this.close(), 8000);
    }

    playIn() {
      if (!this.sheet.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.sheet.style.opacity = '1';
        this.sheet.style.transform = 'translate3d(0, 0, 0) scale(1)';
        return;
      }

      this.sheet.animate([
        { opacity: 0, transform: 'translate3d(0, 50px, 0) scale(.96)' },
        { opacity: 1, transform: 'translate3d(0, -7px, 0) scale(1.012)', offset: .62 },
        { opacity: 1, transform: 'translate3d(0, 2px, 0) scale(.996)', offset: .84 },
        { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)' }
      ], {
        duration: 320,
        easing: 'linear',
        fill: 'forwards'
      });
    }

    playOut() {
      if (!this.sheet.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.sheet.style.opacity = '0';
        this.sheet.style.transform = 'translate3d(0, 14px, 0) scale(.98)';
        return;
      }

      this.sheet.animate([
        { opacity: 1, transform: this.sheet.style.transform || 'translate3d(0, 0, 0) scale(1)' },
        { opacity: 0, transform: 'translate3d(0, 14px, 0) scale(.98)' }
      ], {
        duration: 220,
        easing: 'linear',
        fill: 'forwards'
      });
    }

    resolveItem(detail) {
      if (detail.item) return detail.item;

      if (detail.cart && detail.variantId) {
        var variantId = String(detail.variantId);
        var cartItem = (detail.cart.items || []).find((item) => {
          return String(item.variant_id || item.id) === variantId;
        });

        if (cartItem) return cartItem;
      }

      return {};
    }

    updateProduct(item) {
      var title = item.product_title || item.title || 'OLITANS Gear';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var image = this.getImageUrl(item);
      var price = item.final_price || item.price || this.getUnitPriceFromLine(item);

      this.title.textContent = title;
      this.variant.textContent = variant;
      this.variant.hidden = !variant;
      this.price.innerHTML = this.formatMoney(price);

      if (image) {
        this.image.src = image;
        this.image.alt = title;
        this.image.closest('.olitans-glass-product-image-wrap').hidden = false;
      } else {
        this.image.removeAttribute('src');
        this.image.alt = '';
        this.image.closest('.olitans-glass-product-image-wrap').hidden = true;
      }
    }

    getImageUrl(item) {
      if (item.featured_image && typeof item.featured_image === 'object') {
        return item.featured_image.url || item.featured_image.src || null;
      }

      return item.image || item.featured_image || null;
    }

    formatMoney(value) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(value, window.money_format);
      }

      return '$' + (Number(value || 0) / 100).toFixed(2);
    }

    getUnitPriceFromLine(item) {
      var quantity = Number(item.quantity || 1);
      var linePrice = item.final_line_price || item.line_price || 0;

      return quantity > 0 ? Math.round(Number(linePrice) / quantity) : linePrice;
    }

    loadRecommendations(item) {
      var productId = item.product_id;
      var requestId = ++this.recommendationRequestId;

      this.renderFallbackRecommendations();

      if (!productId || !window.fetch) return;

      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=4', {
        credentials: 'same-origin'
      })
        .then((response) => response.ok ? response.json() : null)
        .then((payload) => {
          if (requestId !== this.recommendationRequestId) return;
          var products = payload && payload.products ? payload.products : [];
          var recommendations = products.filter((product) => product && product.id !== productId).slice(0, 2);

          if (recommendations.length) this.renderRecommendations(recommendations);
        })
        .catch(() => {});
    }

    renderRecommendations(products) {
      this.recommendationsGrid.innerHTML = products.map((product) => {
        var image = product.featured_image || product.images && product.images[0] || '';
        var price = typeof product.price !== 'undefined' ? this.formatMoney(product.price) : 'Carry upgrade';

        return [
          '<a class="olitans-glass-recommendation-card" href="', this.escape(product.url || '#'), '">',
            '<span class="olitans-glass-recommendation-media" aria-hidden="true">',
              image ? '<img src="' + this.escape(image) + '" alt="" loading="lazy">' : '',
            '</span>',
            '<span class="olitans-glass-recommendation-copy">',
              '<span class="olitans-glass-recommendation-title">', this.escape(product.title || 'OLITANS Gear'), '</span>',
              '<span class="olitans-glass-recommendation-subtitle">', price, '</span>',
            '</span>',
          '</a>'
        ].join('');
      }).join('');
    }

    renderFallbackRecommendations() {
      this.recommendationsGrid.innerHTML = [
        this.fallbackCard('Titanium Pry Bar', 'Pocket tool'),
        this.fallbackCard('Titanium Bead', 'Carry detail')
      ].join('');
    }

    fallbackCard(title, subtitle) {
      return [
        '<a class="olitans-glass-recommendation-card" href="/collections/accessories">',
          '<span class="olitans-glass-recommendation-media" aria-hidden="true"></span>',
          '<span class="olitans-glass-recommendation-copy">',
            '<span class="olitans-glass-recommendation-title">', this.escape(title), '</span>',
            '<span class="olitans-glass-recommendation-subtitle">', this.escape(subtitle), '</span>',
          '</span>',
        '</a>'
      ].join('');
    }

    onPointerDown(event) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      if (event.button !== 0 && event.pointerType === 'mouse') return;
      if (this.isInteractiveTarget(event.target)) return;

      this.drag = {
        id: event.pointerId,
        startY: event.clientY,
        currentY: event.clientY
      };

      this.sheet.setPointerCapture(event.pointerId);
      this.sheet.addEventListener('pointermove', this.onPointerMoveBound = this.onPointerMove.bind(this));
      this.sheet.addEventListener('pointerup', this.onPointerUpBound = this.onPointerUp.bind(this), { once: true });
      this.sheet.addEventListener('pointercancel', this.onPointerUpBound, { once: true });
    }

    isInteractiveTarget(target) {
      if (!target || !target.closest) return false;

      return Boolean(target.closest('a, button, input, select, textarea, summary, label, [role="button"], [data-olitans-glass-close]'));
    }

    onPointerMove(event) {
      if (!this.drag || event.pointerId !== this.drag.id) return;

      var deltaY = Math.max(0, event.clientY - this.drag.startY);
      this.drag.currentY = event.clientY;
      this.sheet.style.transform = 'translate3d(0, ' + deltaY + 'px, 0) scale(' + Math.max(.98, 1 - deltaY / 1600) + ')';
    }

    onPointerUp(event) {
      if (!this.drag || event.pointerId !== this.drag.id) return;

      var deltaY = Math.max(0, this.drag.currentY - this.drag.startY);
      this.sheet.releasePointerCapture(event.pointerId);
      this.sheet.removeEventListener('pointermove', this.onPointerMoveBound);
      this.sheet.removeEventListener('pointercancel', this.onPointerUpBound);
      this.drag = null;

      if (deltaY > 70) {
        this.close();
      } else {
        this.playIn();
      }
    }

    escape(value) {
      var div = document.createElement('div');
      div.textContent = value == null ? '' : String(value);
      return div.innerHTML;
    }
  }

  function init() {
    var root = document.querySelector('[data-olitans-glass-cart-success]');
    if (!root) return;

    window.olitansGlassCartSuccess = new OlitansGlassCartSuccess(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
